<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <breadcrumb-slot :items="items" :modal="false"></breadcrumb-slot>

        <div class="p-1 d-flex justify-content-between">
            <h2 class="text-dark">ტუბ. დაწესებულებები</h2>

            <b-button variant="primary" class="mb-3">
                <feather-icon icon="PlusCircleIcon"
                              class="mr-50"/>
                <span class="align-middle">რეგიონის დამატება</span>
            </b-button>
        </div>

        <good-table-basic :rows="rows" :title="'აჭარა'" :columns="columns"></good-table-basic>
        <good-table-basic :rows="rows" :title="'გურია'" :columns="columns"></good-table-basic>
        <good-table-basic :rows="rows" :title="'იმერეთი'" :columns="columns"></good-table-basic>
    </div>
</template>

<script>

    import BreadcrumbSlot from "../../components/breadcrumb/BreadcrumbSlot";
    import GoodTableBasic from "../../table/vue-good-table/GoodTableBasic";
    import { BButton } from "bootstrap-vue"
    export default {
        components: {
            GoodTableBasic,
            BreadcrumbSlot,
            BButton
        },
        data() {
            return {
                data: {},
                items: [
                    {
                        text: "დაწესებულებები",
                        active: true
                    }
                ],
                rows: [
                    {
                        "id": 1,
                        "avatar": "/img/10-small.2b24b197.png",
                        "fullName": "Korrie O'Crevy",
                        "email": "kocrevy0@thetimes.co.uk",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 2,
                        "avatar": "/img/1-small.1b74d2ba.png",
                        "fullName": "Bailie Coulman",
                        "email": "bcoulman1@yolasite.com",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 3,
                        "avatar": "/img/9-small.30df7a62.png",
                        "fullName": "Stella Ganderton",
                        "email": "sganderton2@tuttocitta.it",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 4,
                        "avatar": "/img/3-small.33d29f56.png",
                        "fullName": "Dorolice Crossman",
                        "email": "dcrossman3@google.co.jp",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 5,
                        "avatar": "/img/4-small.2149d551.png",
                        "fullName": "Harmonia Nisius",
                        "email": "hnisius4@gnu.org",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 6,
                        "avatar": "/img/5-small.a4eb6d6e.png",
                        "fullName": "Genevra Honeywood",
                        "email": "ghoneywood5@narod.ru",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 7,
                        "avatar": "/img/7-small.c4993d9a.png",
                        "fullName": "Eileen Diehn",
                        "email": "ediehn6@163.com",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 8,
                        "avatar": "/img/9-small.30df7a62.png",
                        "fullName": "Richardo Aldren",
                        "email": "raldren7@mtv.com",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 9,
                        "avatar": "/img/2-small.de63ead1.png",
                        "fullName": "Allyson Moakler",
                        "email": "amoakler8@shareasale.com",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }, {
                        "id": 10,
                        "avatar": "/img/6-small.c9b47a98.png",
                        "fullName": "Merline Penhalewick",
                        "email": "mpenhalewick9@php.net",
                        "startDate": "14",
                        "salary": "5",
                        "status": "7"
                    }
                ],
                columns: [
                    {
                        label: "ქალაქი",
                        field: "fullName",
                    },
                    {
                        label: "მისამართი",
                        field: "email",
                    },
                    {
                        label: "ანგარიშები",
                        field: "startDate",
                    },
                    {
                        label: "ინდექსები",
                        field: "salary",
                    },
                    {
                        label: "კონტაქტები",
                        field: "status",
                    },
                    {
                        label: "რისკ-ჯგუფები",
                        field: "status",
                    },
                    {
                        label: "",
                        field: "action",
                    },
                ],
            }
        }
    }
</script>

<style lang="scss">
</style>
